/**
 * @fileoverview GET handler for the "/engagement/email_template_sources" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementEmailTemplateSources } from "./constants";
import type { EmailTemplateSourcesResult } from "./types";
import { isEmailTemplateSourcesResult } from "./validators";

export const getEmailTemplateSources = reactQueryFetcherAdapter(
  engagementEmailTemplateSources,
  (signal: AbortSignal, appGroupId: string): Promise<EmailTemplateSourcesResult> => {
    return fetch(
      "/engagement/email_template_sources",
      "GET",
      {
        app_group_id: appGroupId,
      },
      { signal }
    );
  },
  isEmailTemplateSourcesResult
);
